import {Pipe, PipeTransform} from '@angular/core';
import {OriginalPapayaViewerSlice} from '../../../dashboard-study-papaya/types/dashboard-study-papaya-original.types';

@Pipe({ name: 'dashboardStudyViewerZoomedControlsSliceName' })
export class DashboardStudyViewerZoomedControlsSliceNamePipe implements PipeTransform {
  transform(sliceOrder: OriginalPapayaViewerSlice[], currentIndex: number, sliceToExtract: 'previous' | 'current' | 'next'): string {
    // Define the slice name based on the slice order and the current slice index.
    switch (sliceToExtract) {
      case 'previous':
        const previousSliceIndex = currentIndex - 1 < 0 ? 2 : currentIndex - 1;
        const previousSlice = sliceOrder[previousSliceIndex];
        return OriginalPapayaViewerSlice[previousSlice];
      case 'current':
        const currentSlice = sliceOrder[currentIndex];
        return OriginalPapayaViewerSlice[currentSlice];
      case 'next':
        const nextSliceIndex = currentIndex + 1 > 2 ? 0 : currentIndex + 1;
        const nextSlice = sliceOrder[nextSliceIndex];
        return OriginalPapayaViewerSlice[nextSlice];
    }
  }
}
